export default class TurboAdminMenuItem {

	constructor(title, action, parentTitle) {
		this.title = title;
		this.action = action;
		this.parentTitle = parentTitle;
	}
}
